import React from 'react';

export const ExpiredLinkIcon: React.FC = () => (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Clock face */}
        <circle cx="30" cy="36" r="22" stroke="#f59e0b" strokeWidth="3" fill="none" />
        {/* Clock hands */}
        <line x1="30" y1="36" x2="30" y2="23" stroke="#f59e0b" strokeWidth="3" strokeLinecap="round" />
        <line x1="30" y1="36" x2="41" y2="36" stroke="#f59e0b" strokeWidth="3" strokeLinecap="round" />
        {/* X badge */}
        <circle cx="49" cy="15" r="11" fill="#1f2937" />
        <circle cx="49" cy="15" r="9" fill="#f59e0b" />
        <line x1="45" y1="11" x2="53" y2="19" stroke="#1f2937" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="53" y1="11" x2="45" y2="19" stroke="#1f2937" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
);
